import React, { useEffect, useState } from "react";
import trail from "remove-trailing-spaces";
import Navigation from "../../components/navigation";

import translations from "../../content/spanish";
import Box from "../../components/box";
import Form from "../../components/form";
import TitleScreen from "../../components/title-screen";

const getRandomNumber = (max) => Math.floor(Math.random() * max);
const getOrder = (language = "en") =>
  language === "en"
    ? ["statements", "actions", "labels", "adjectives", "categories", "nouns"]
    : ["statements", "actions", "labels", "categories", "adjectives", "nouns"];

const Spanish = () => {
  const [question, setQuestion] = useState("");
  const [inProgress, setInProgress] = useState("");
  const [answer, setAnswer] = useState("");
  const [status, setStatus] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [input, setInput] = useState("");
  const [options, setOptions] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const backToHomeScreen = () => setInProgress(false);

  const reset = () => {
    setAnswer("");
    setInput("");
    setIsSubmitted(false);
    setQuestion("");
    setStatus("");
    setInProgress(true);
  };

  const getPhrase = (type = "", selection = "") => {
    if (!selection) return "";

    const array = translations[type][selection];
    const index = getRandomNumber(array.length);

    return array[index];
  };

  const generate = (newOptions) => {
    const opts = newOptions || options;

    if (!Object.keys(opts).length) return;

    reset();
    setOptions(opts);

    let question = {};
    let answer = {};

    Object.keys(opts).forEach((opt) => {
      const phrase = getPhrase(opt, opts[opt]);

      if (!phrase) return;

      question[opt] = phrase.en;
      answer[opt] =
        typeof phrase.es === "object" ? phrase.es.plural : phrase.es;
    });

    setQuestion(format(question, "en"));
    setAnswer(format(answer, "es"));
  };

  const format = (sentence, language) => {
    let string = "";
    getOrder(language).forEach((type) => {
      const match = sentence[type];
      if (match) string += `${match} `;
    });

    return trail(string);
  };

  const skip = () => generate(options);

  const handleInputChange = (input) => setInput(input);

  const handleSubmit = () => {
    const val = document.getElementById("answer").value;
    const isSuccess = val && val.toLowerCase() === answer.toLowerCase();
    setStatus(isSuccess ? "success" : "error");
    setIsSubmitted(true);
  };

  return (
    <>
      <Navigation theme={`${inProgress ? "light" : "dark"}`} />
      <TitleScreen config={translations} hide={inProgress} onClick={generate} />
      <div
        className={`${isSubmitted ? "squash" : ""}${inProgress ? "" : " hide"}`}
      >
        <Box text={question} />
        <Form
          end={backToHomeScreen}
          isDirty={!input}
          onChange={handleInputChange}
          onSubmit={handleSubmit}
          reset={generate}
          skip={skip}
          status={status}
        />
        {isSubmitted && <Box text={answer} status={status} />}
        <div
          className={`arrow${status !== "success" ? " hide" : ""}`}
          onClick={() => generate(options)}
        />
      </div>
    </>
  );
};

export default Spanish;
